import { BroadcastPaywall } from 'apps/posting/constants'
import { billing, RequestUpgradePayload } from 'common/billing'
import { Ability } from 'common/core/constants/Ability'

import { WhatsAppPaywall } from '../constants'

/**
 * Displays upgrade modal when connecting WhatsApp channel
 * @param payload - Same as RequestUpgradePayload but without abilities
 * @returns result of billing.requestUpgrade
 */
export const requestWAConnectionUpgrade = (payload: Omit<RequestUpgradePayload, 'abilities'>) => {
  return billing.requestUpgrade({
    ...payload,
    abilities: [Ability.WA_CHANNEL, Ability.CHANNELS_COUNT],
  })
}

/**
 * Displays upgrade modal when account is free and wants to upgrade to Pro
 * @param payload - Same as RequestUpgradePayload but without abilities
 * @returns result of billing.requestUpgrade
 */
export const requestWAUpgrade = (payload: Omit<RequestUpgradePayload, 'abilities'>) => {
  return billing.requestUpgrade({
    ...payload,
    abilities: [Ability.WA_CHANNEL],
    paywall: WhatsAppPaywall,
  })
}

/**
 * Displays upgrade modal for WA Broadcast creation
 * @param payload - Same as RequestUpgradePayload but without abilities
 * @returns result of billing.requestUpgrade
 */
export const requestWABroadcastUpgrade = (payload: Omit<RequestUpgradePayload, 'abilities'>) => {
  return billing.requestUpgrade({
    ...payload,
    abilities: [Ability.WA_CHANNEL, Ability.BROADCASTING],
    paywall: BroadcastPaywall,
  })
}
